(() => {
  const INTRO_KEY = "siteIntroSeen";
  const intro = document.getElementById("site-intro");
  const logo = intro?.querySelector(".site-intro__logo");
  const tagline = intro?.querySelector(".site-intro__tagline");

  if (!intro || !logo) return;

  // Show once per session
  if (sessionStorage.getItem(INTRO_KEY) === "1") {
    intro.remove();
    return;
  }
  sessionStorage.setItem(INTRO_KEY, "1");

  const HOLD_MS = 1800;   // how long it stays visible
  const FADE_MS = 800;    // must match CSS transition duration

  window.addEventListener("load", () => {
    setTimeout(() => {
      // Fade logo + tagline + background together
      logo.classList.add("logo-fade-out");
      tagline?.classList.add("tagline-fade-out");
      intro.classList.add("is-hidden");

      // Remove after fade completes
      setTimeout(() => intro.remove(), FADE_MS + 50);
    }, HOLD_MS);
  });
})();